import React, { useEffect, useState } from "react";
import Editor from "../../../components/Editor";
import { Button } from "../../../components/ui/button";
import { Eye } from "lucide-react";
import { API, fileUpload } from "../../../config";
import ReceiptDetailsPopup from "../../Receipts/ReceiptDetailsPopup";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import SearchSelect from "../../../components/SearchSelect";

const ReceiptTemplate = ({
  templateData,
  setLoading,
  fetchTemplateData,
  trustId,
  receipt_template_type
}) => {
  let defaultText = `Agents Financial Administration Act 2014`;

  const [value, setValue] = useState(templateData ? templateData : defaultText);
  const [showView, setShowView] = useState();

  const [type, setType] = useState(receipt_template_type ? receipt_template_type : "1");

    const receiptTemplateType = [
    { label: "Letter", value: "1" },
    { label: "Boxed", value: "2" },
  ];

  useEffect(() => {
    setValue(templateData ? templateData : defaultText);
  }, [defaultText, templateData]);

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("value", value);
      formData.append("receipt_template_type", type);
      formData.append("type", "receipt");
      formData.append("_method", "put");
      const { data } = await fileUpload(
        `${API.TEMPLATE_UPADATE}/${trustId}`,
        formData
      );
      if (data) {
        fetchTemplateData();
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="grid gap-2">
        <Label htmlFor="base_type">
          <CustomLabelText
            required={true}
            labelText="Receipt Template Type"
          />
        </Label>
        <div className="relative max-w-40 mb-3">
          <SearchSelect
            frameworks={receiptTemplateType}
            optionType={"Receipt Template Type"}
            handleSelect={(e) => {
              setType(e);
            }}
            disabled={false}
            initialValue={type}
          />
        </div>
      </div>
      <Editor value={value} setValue={(data) => setValue(data)} />
      <div className="flex w-full items-center justify-between mt-4">
        <Button
          onClick={() => {
            toggleShowModal();
          }}
        >
          <span className="flex items-center gap-1">
            <Eye size={18} /> Preview
          </span>
        </Button>
        <Button
          onClick={() => {
            handleSave();
          }}
        >
          Save
        </Button>
      </div>
      {showView && (
        <ReceiptDetailsPopup
          showView={showView}
          setShowView={setShowView}
          popupType={"template"}
          value={value}
          type={type}
        />
      )}
    </>
  );
};

export default ReceiptTemplate;
